import React, { Component } from 'react';
import { Row, Col, Image, Button } from 'react-bootstrap';
import linkedin from '../../assets/images/icons/linkedin_icon.svg';
import twitter from '../../assets/images/icons/twitter.svg';
import hyperlinks from "../../../src/util/hyperlinks";



export default class Footer extends Component {
    constructor(props) {
        super(props);
    };

    render() {
        return(
            <Row className="footer-top-border">
                <Col md={2} className="logo-container ">
                    <a href={hyperlinks["home"]}>
                        <Image src="/assets/LUOW_2024_Vertical_Blue-3597b4329063f0d9e23bb1a88845acab12f8457a3301b5e03bb998631c5684d9.svg" className="nav-logo" />
                    </a>
                </Col>
                <Col md={2}>
                    <ul className="list-group">
                        <li className="h4 text-grey footer-header">Join Us</li>
                        <li><a href={hyperlinks["membership"]} className="text-grey list-group-item-action">Utility Membership</a></li>
                        <li><a href={hyperlinks["corporateMembership"]} className="text-grey list-group-item-action">Corporate Membership</a></li>
                        <li><a href="https://leading-utilities-of-the-world-network.mn.co/sign_in?from=https%3A%2F%2Fleading-utilities-of-the-world-network.mn.co%2Ffeed" className="text-grey list-group-item-action">Member Login</a></li>
                        <li><a href={hyperlinks["currentMembers"]} className="text-grey list-group-item-action">Meet the Member</a></li>
                    </ul>
                </Col>
                <Col md={2}>
                    <ul className="list-group">
                        <li className="h4 footer-header">About</li>
                        <li><a href={hyperlinks["aboutUs"]} className="text-grey list-group-item-action">About Us</a></li>
                        <li><a href={hyperlinks["privacyPolicy"]} className="text-grey list-group-item-action">Privacy Policy</a></li>
                        <li><a href={hyperlinks["platformGuidelines"]} className="text-grey list-group-item-action">Platform Guidelines</a></li>
                        <li><a href={hyperlinks["termsAndConditions"]} className="text-grey list-group-item-action">Ts & Cs</a></li>
                    </ul>
                </Col>
                <Col md={2}>
                    <ul className="list-group">
                        <li className="h4 footer-header">Related</li>
                        <li><a href="https://www.globalwaterleaders.org" target="_blank" className="text-grey list-group-item-action">Global Water Leaders Group</a></li>
                        <li><a href="https://www.globalwaterintel.com" target="_blank" className="text-grey list-group-item-action">Global Water Intelligence</a></li>
                        <li><a href="https://www.watermeetsmoney.com" target="_blank" className="text-grey list-group-item-action">Global Water Summit</a></li>
                    </ul>
                </Col>
                <Col md={2}>
                    <ul className="list-group">
                        <li className=""><a href={hyperlinks["contactUs"]} className="h4 footer-header text-grey list-group-item-action">Contact Us</a></li>  
                        <li className="text-grey">Kings Mead House</li>
                        <li className="text-grey">Oxpens Road</li>
                        <li className="text-grey">Oxford</li>
                        <li className="text-grey">OX1 1XX</li>
                        <li><a className="text-grey list-group-item-action" href="mailto:contact@globalwaterleaders.org">contact@globalwaterleaders.org</a></li>
                    </ul>
                </Col> 
                <Col className="logo-container">
                    <ul className="list-group">
                        <li>
                            <a
                                href="https://www.linkedin.com/showcase/leading-utilities-of-the-world"
                                target="_blank"
                                className="social-icon-wrapper"
                            >
                                <Image src={linkedin} className="social-icon" alt="Follow us on linkedin" />
                            </a>
                        </li>
                        <li>
                            <a
                                href="https://www.twitter.com/waterleaders"
                                target="_blank"
                                className="social-icon-wrapper"
                            >
                                <Image src={twitter} className="social-icon" alt="Follow us on Twitter" />
                            </a>
                        </li>
                    </ul>
                </Col>
            </Row>
        )
    }
}

                  


// WEBPACK FOOTER //
// ./app/javascript/components/Footer.jsx.erb